import { Routes } from "constants/routes";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { INotification, UrlQueryParams } from "../../store/types";
import { JSON_to_URLEncoded } from "../../utils";
import { NotificationHandlerType } from "./use-click-handler";

export function useTaskHook(): NotificationHandlerType {
  const { push } = useHistory();

  return useCallback(async ({ components }: INotification) => {
    const searchObj: UrlQueryParams = {
      task: components.task_id
    };
    if (components.task_id) {
      push({
        pathname: Routes.taskManagement,
        search: JSON_to_URLEncoded(searchObj)
      });
    }
  }, []);
}
